import { Link } from 'react-router-dom'
import { Shield, FileText, AlertTriangle, CheckCircle } from 'lucide-react'

export default function HomePage() {
  const features = [
    {
      icon: FileText,
      title: 'AI Contract Analysis',
      description: 'Upload contracts and get instant risk assessment with AI-powered analysis',
    },
    {
      icon: Shield,
      title: 'Compliance Monitoring',
      description: 'Track compliance deadlines and requirements across all your projects',
    },
    {
      icon: AlertTriangle,
      title: 'Risk Management',
      description: 'Identify and mitigate legal risks before they become problems',
    },
    {
      icon: CheckCircle,
      title: 'Lawyer Approval',
      description: 'All documents reviewed and approved by licensed attorneys',
    },
  ]

  return (
    <div className="min-h-screen">
      <div className="bg-gradient-to-br from-primary-600 to-primary-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              AI-Powered Legal Compliance
              <br />
              for Construction
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-primary-100">
              Protect your construction business with automated compliance monitoring,
              <br />
              contract analysis, and lawyer-approved legal documents.
            </p>
            <p className="text-base mb-6 text-primary-100">
              30-day free trial. Billing starts only after the trial ends.
            </p>
            <div className="flex justify-center space-x-4">
              <Link
                to="/register"
                className="px-8 py-3 bg-white text-primary-600 font-semibold rounded-lg hover:bg-gray-100 transition"
              >
                Start Free Trial
              </Link>
              <Link
                to="/login"
                className="px-8 py-3 bg-primary-700 text-white font-semibold rounded-lg hover:bg-primary-800 transition"
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Powerful Features for Construction Law</h2>
            <p className="mt-4 text-xl text-gray-600">
              Everything you need to manage legal compliance and reduce risk
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="p-3 bg-primary-100 rounded-lg">
                    <feature.icon className="h-8 w-8 text-primary-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Trusted by Construction Professionals</h2>
          <p className="text-xl text-gray-600 mb-8">
            Built by lawyers who understand construction law
          </p>
          <Link
            to="/register"
            className="inline-block px-8 py-3 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-700 transition"
          >
            Get Started Today
          </Link>
        </div>
      </div>
    </div>
  )
}